// extracted by mini-css-extract-plugin
export default {"base_button":"baseButton_base_button__3h0dg"};